import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/user-role'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({ commit, dispatch }, payload) {
    let url = 'api/user-role'
    let params = {
      'user_id': payload.user.id,
      'role_id': payload.roles.id
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({ commit, dispatch }, payload) {
    let url = 'api/user-role/' + payload.role.id + '/' + payload.user.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the userRoles endpoint
  onGet (state, payload) {
    let userRoles = payload.response.data.data
    payload.event.context.userRoles = userRoles
  },
  // Creates a relationship of user with role
  onPost (state, payload) {
    // payload.event.context.showNotification(payload.response, 'success')
    // payload.event.context.close()
    // payload.event.context.refresh()
  },
  // Removes the relationship of user with role
  onDelete (state, payload) {
    // payload.event.context.closeDelete()
    // payload.event.context.refresh()
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    // payload.event.context.showNotification(payload.error.response, 'error', -1)
    // payload.event.context.refresh()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userRole.js